import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/legal")({
  head: () => ({
    meta: [
      { title: "Legal — Routify" },
      { name: "description", content: "Legal information, terms, privacy and cookies for Routify." },
    ],
  }),
  component: LegalIndex,
});

function LegalIndex() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-16 text-foreground">
      <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">← Home</Link>
      <h1 className="mt-6 text-3xl font-semibold">Legal / Informação Legal</h1>
      <p className="mt-4 text-sm text-muted-foreground">
        Service provider identification, as required by Portuguese Decree-Law 7/2004 and EU
        Directive 2000/31/EC. Identificação do prestador de serviços, nos termos do DL 7/2004
        e da Diretiva 2000/31/CE.
      </p>

      <div className="mt-6 rounded-lg border border-border bg-card p-5 text-sm leading-relaxed">
        <p><strong>Service provider / Prestador:</strong> João Marcelo Borges Pinto de Freixo</p>
        <p><strong>Address / Morada:</strong> Rua de Balagão, cx 634, 4630-211 Soalhães, Marco de Canaveses, Portugal</p>
        <p><strong>VAT / NIF:</strong> PT 266 298 583</p>
        <p><strong>Email:</strong> <a className="underline" href="mailto:Routify.info@gmail.com">Routify.info@gmail.com</a></p>
        <p className="mt-2 text-xs text-muted-foreground">
          Activity: provision of an AI-assisted online itinerary planning service (CAE 63110 / 79900).
        </p>
      </div>

      <div className="mt-6 rounded-lg border border-border bg-card p-5 text-sm leading-relaxed">
        <p className="font-semibold">Consumer dispute resolution / Resolução alternativa de litígios</p>
        <p className="mt-2">
          In case of a dispute, consumers may resort to the following entities (Law 144/2015):
        </p>
        <ul className="mt-2 list-disc pl-5">
          <li>
            <strong>CNIACC</strong> — Centro Nacional de Informação e Arbitragem de Conflitos de
            Consumo: <a className="underline" href="https://www.cniacc.pt" target="_blank" rel="noreferrer">cniacc.pt</a>
          </li>
          <li>
            <strong>EU ODR Platform</strong>:{" "}
            <a className="underline" href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">
              ec.europa.eu/consumers/odr
            </a>
          </li>
          <li>
            <strong>Livro de Reclamações</strong> eletrónico:{" "}
            <a className="underline" href="https://www.livroreclamacoes.pt" target="_blank" rel="noreferrer">
              livroreclamacoes.pt
            </a>
          </li>
        </ul>
      </div>

      <ul className="mt-8 space-y-2 text-sm">
        <li><Link to="/terms" className="underline">Terms &amp; Conditions / Termos e Condições</Link></li>
        <li><Link to="/privacy" className="underline">Privacy Policy / Política de Privacidade</Link></li>
        <li><Link to="/cookies" className="underline">Cookie Policy / Política de Cookies</Link></li>
        <li><Link to="/partner-terms" className="underline">Partner Programme Terms / Termos do Programa de Parceiros</Link></li>
      </ul>
    </main>
  );
}
